<template>
    <div class="page">
        <div class="stage_body">
            <div class="top_label">
                <span class="lable_name">分层教学</span>
            </div>

            <div v-if="work_data.length">
                <div class="stag_top_box">

                    <div class="stag_top_left">
                        <span class="icon">
                            <i style="font-size: 24px;" class="el-icon-coffee-cup"></i>
                        </span>
                        
                        <div class="stag_top_left_title">
                            <span class="name">分层教学 · 自适应体系</span>
                            <span class="info">学号制学习路径 | 动态晋级 | {{stage.length}} 阶能力模型</span>
                        </div>
                    </div>
                    <div class="stag_top_right">
                        <i style="font-size: 16px;" class="el-icon-success"></i>
                        <div>当前在学：<span style="color:#F56C6C">{{level_obj.name}}</span> 层 | 当前阶段：<span style="color:#F56C6C">{{current}}</span> 层 {{level_obj.starttime_text}} - {{level_obj.endtime_text}}</div>
                    </div>
                </div>

                <div class="stag_list_box">
                    <div @click="changeLevel(item)" v-for="(item,index) in stage" :key="index" :class="['stag_list_item',{'stage_list_active':level == item.name}]" >
                        <div class="stag_list_item_top">
                            <div class="stag_list_item_top_left">
                                <span class="stage_name">{{item.char}}</span>
                                <div class="stag_list_item_top_left_time">
                                    <i class="el-icon-date"></i>
                                    <span> {{item.starttime_text}} ~ {{item.endtime_text}}</span>
                                </div>
                                
                            </div>
                            <div>
                                <span class="stag_list_item_top_right">{{tag_type[index]}}</span>
                            </div>
                            
                        </div>
                        <div class="stag_list_info">
                            <i class="el-icon-warning"></i>
                            <div class="stag_list_info_content">
                                <span>阶段要求：{{item.signs}}分 & 准确率 ≥ {{item.score}}%</span>
                                <span style="font-weight:700" v-if="item?.is_complete !== undefined">→ 阶段考核</span>
                                <span v-if="item?.is_complete !== undefined">进度：总积分 {{item.total_integrallist}}分 | 正确率 {{item.svg_t_score}}%</span>
                                <span v-else>完成上一阶段要求解锁</span>
                            </div>
                        </div>
                        <el-progress style="margin-top: 10px;" :show-text="false" :stroke-width="8" :color="item.signs && getProgressstag(item.total_integrallist,item.signs,item.is_complete) < 50?'#F56C6C':(item.signs && getProgressstag(item.total_integrallist,item.signs,item.is_complete) < 70?'#E6A23C':'#409EFF')" :percentage="item.signs && getProgressstag(item.total_integrallist,item.signs,item.is_complete)"></el-progress>
                        <span v-if="level == item.name || item?.is_complete !== undefined" class="stag_list_info_text">
                            {{item.uncomplete_integrallist <= 0?'积分已达标':`还差${item.uncomplete_integrallist}分`}} + {{item.uncomplete_score <=0 ?'正确率已达标':`提升准确率至${item.score}%`}}
                            
                            
                            </span>
                        <span v-else class="stag_list_info_text">当前阶段未解锁</span>
                    </div>

                </div>
                
                <div class="stag_work_list">
                    <div class="stag_work_list_item">
                        <div class="stag_work_list_item_icon">
                            <span class="stag_work_list_item_left">
                                <i class="el-icon-trophy"></i>
                            </span>
                        </div>
                        
                        <div class="stag_work_list_item_right">
                            <span class="stag_work_list_item_right_name">{{level_obj.name}}层 总积分</span>
                            <div class="stag_work_list_item_right_score"><span style="color:#F56C6C">{{level_obj.total_integrallist}}</span> <span class="stage_targetsign">/ {{level_obj.signs}}</span></div>
                            <el-progress :show-text="false" :stroke-width="7" :color="level_obj.signs && getProgress(level_obj.total_integrallist,level_obj.signs) < 50?'#F56C6C':(level_obj.signs && getProgress(level_obj.total_integrallist,level_obj.signs) < 70?'#E6A23C':'#409EFF')" :percentage="level_obj.signs && getProgress(level_obj.total_integrallist,level_obj.signs)"></el-progress>
                            <span class="stag_work_list_item_right_text">提升积分至{{level_obj.total_integrallist}}分</span>
                        </div>
                    </div>
                    <div class="stag_work_list_item">
                        <div class="stag_work_list_item_icon">
                            <span style="color: #F56C6C;background: #FDE2E2;" class="stag_work_list_item_left">
                                <i style="font-size:20px" class="el-icon-guide"></i>
                            </span>
                        </div>
                        <div class="stag_work_list_item_right">
                            <span class="stag_work_list_item_right_name">当前平均正确率</span>
                            <div class="stag_work_list_item_right_score">
                                <span>{{level_obj.svg_t_score}}</span>
                                <span style="font-size:14px">%</span>
                            </div>
                            <el-progress :show-text="false" :stroke-width="7" :color="level_obj.svg_t_score < 50?'#F56C6C':(level_obj.svg_t_score < 70?'#E6A23C':'#409EFF')" :percentage="level_obj.svg_t_score?level_obj.svg_t_score:0"></el-progress>
                            <span class="stag_work_list_item_right_text">提升准确率至{{level_obj.score}}%</span>
                        </div>
                    </div>
                    <div class="stag_work_list_item">
                        <div class="stag_work_list_item_icon">
                            <span style="color: #9333ea;background: #f3e8ff;" class="stag_work_list_item_left">
                                <i style="font-size:20px" class="el-icon-s-opportunity"></i>
                            </span>
                        </div>
                        <div class="stag_work_list_item_right">
                            <span class="stag_work_list_item_right_name">今日可用积分</span>
                            <div class="stag_work_list_item_right_score"><span style="color:#F56C6C">{{today_grade.today_integrallist}}</span> <span style="font-size:14px"> / {{store.number}}</span></div>
                            <el-progress :show-text="false" :stroke-width="7" :color="store.number && getProgress(today_grade.today_integrallist,store.number) < 50?'#F56C6C':(store.number && getProgress(today_grade.today_integrallist,store.number) < 70?'#E6A23C':'#409EFF')" :percentage="store.number && getProgress(today_grade.today_integrallist,store.number)"></el-progress>
                            <span class="stag_work_list_item_right_text">每篇2分，每日积分上限{{store.number}}分</span>
                        </div>
                    </div>
                    <div class="stag_work_list_item">
                        <div class="stag_work_list_item_icon">
                            <span style="color: #67C23A;background: #E1F3D8;" class="stag_work_list_item_left">
                                <i style="font-size:20px" class="el-icon-edit"></i>
                            </span>
                        </div>
                        <div class="stag_work_list_item_right">
                            <span class="stag_work_list_item_right_name">当前阶段完成篇数</span>
                            <div style="margin-top: 35px;" class="stag_work_list_item_right_score">
                                <span>{{level_obj.total_number}}</span>
                                <span style="font-size:14px;font-weight:normal;margin-left:5px;">篇</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="stag_info_content">
                    <div class="stag_info_content_item">
                        <div class="stag_info_content_item_icon">
                            <i style="font-size:24px" class="el-icon-postcard"></i>
                        </div>
                        <div class="stag_info_content_item_right">
                            <span class="stag_info_content_item_right_name">学号登录强制</span>
                            <span class="stag_info_item_text">请使用统一注册账号登录系统，自行注册账号无法参加阶段考试。</span>
                        </div>
                    </div>
                    <div class="stag_info_content_item">
                        <div class="stag_info_content_item_icon">
                            <i style="font-size:24px" class="el-icon-refresh"></i>
                        </div>
                        <div class="stag_info_content_item_right">
                            <span class="stag_info_content_item_right_name">材料重置机制</span>
                            <div class="stag_info_item_text">每篇材料可重置 <span style="color:red;font-weight:bold;font-size:18px;">{{store.frequency}}</span>次，重置次数用完不可再提交。{{store.frequency}}次后可直接查看解析。</div>
                        </div>
                    </div>
                    <div class="stag_info_content_item">
                        <div class="stag_info_content_item_icon">
                            <i style="font-size:24px" class="el-icon-document-checked"></i>
                        </div>
                        <div class="stag_info_content_item_right">
                            <span class="stag_info_content_item_right_name">解析门槛</span>
                            <div class="stag_info_item_text">正确率<span style="color:red;font-weight:bold;font-size:18px;">≥ {{store.analysis}}%</span> 可查看答案解析；重置次数用尽后无视门槛直接解锁解析。</div>
                        </div>
                    </div>
                    <div class="stag_info_content_item">
                        <div class="stag_info_content_item_icon">
                            <i style="font-size:24px" class="el-icon-alarm-clock"></i>
                        </div>
                        <div class="stag_info_content_item_right">
                            <span class="stag_info_content_item_right_name">每日上限</span>
                            <div class="stag_info_item_text">每日积分上限<span style="color:red;font-weight:bold;font-size:18px;">{{store.number}}</span>分，超过不再累计，合理安排练习节奏~</div>
                        </div>
                    </div>
                </div>

                <div class="stag_task_box">
                    <div class="stag_task_box_title">
                        <span style="width:80px">序号</span>
                        <span>任务名称</span>
                        <span>类型</span>
                        <span>题量</span>
                        <span>获得积分</span>
                        <span>平均正确率</span>
                        <span>学习时长</span>
                        <span>操作</span>
                    </div>
                    <div v-for="(item,index) in work_data" :key="index" class="stag_task_box_item">
                        <span class="item">{{index+1}}</span>
                        <span class="item">{{item.title}}</span>
                        <span class="item">{{item.type == 'specialty' ? '应试英语' : '阅读在线'}}</span>
                        <span class="item">{{item.total_number}}</span>
                        <span class="item">{{item.integrallist_score}}分</span>
                        <span class="item">{{item.avg_score}}%</span>
                        <span class="item">{{item.total_time}}</span>
                        <div style="cursor: pointer;" @click="toDetail(item)" class="item">
                            <span style="background: #D9ECFF;border-radius: 20px;padding: 8px 11px;color: #409EFF;">前往做题 <i style="font-size:16px" class="el-icon-right"></i></span>
                        </div>
                    </div>

                    <div class="stag_task_box_item_text">
                        <i class="el-icon-info"></i>
                        <div>每完成一篇练习题得2分，正确率≥{{store.analysis}}%可解锁【解析】。重置{{store.frequency}}次后无论正确率都解锁解析。当前仅<span style="color:red;font-weight:bold;font-size:16px"> {{level}} </span>层可进行学习。</div>
                    </div>
                </div>

                <div class="top_plan_info_title">
                    <i style="color:#409EFF" class="el-icon-edit"></i>
                    <span>做题记录</span>
                </div>
                <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                    </el-table-column>
                    <el-table-column
                        prop="w_id_text"
                        label="标题"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="score"
                        label="正确率"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="time"
                        label="时长"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="type"
                        label="类型"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="createtime"
                        label="做题时间"
                        width="120">
                    </el-table-column>
                </el-table>
                <el-pagination
                    style="margin-top: 20px;"
                    hide-on-single-page
                    @size-change="changeSize"
                    @current-change="changeNumber"
                    @prev-click="prev"
                    @next-click="next"
                    :current-page="page"
                    :page-size="pageSize"
                    :total="total_number">
                </el-pagination> 
            </div>
            
            <div v-else style="margin-top:100px;">
                <el-empty description="当前暂无学习内容"></el-empty>
            </div>
 
        </div>
    </div>
</template>

<script>
import Http from "../../apis/student";
import stagework from "../../../untils/stagework";
export default {
    components:{
        'Stagework':stagework
    },
    data(){
        return{
            colorClass:['greentimelinetitle','bluetimelinetitle','yellowtimelinetitle','redtimelinetitle'],
            tableData: [],
            total_number:0,
            stage:[],
            today_grade:{},
            work_data:{},
            trem:0,
            level:'',
            page:1,
            pageSize:30,
            now_level:{},
            store:{},
            current:'', //当前阶段
            tag_type:[
                '基础构建',
                '能力进阶',
                '卓越冲刺',
                '高阶思维'
            ],
            level_obj:{},
            option_type:0,
            change_level:''
        }
    },

    created(){
        this.$store.dispatch('fetchConfig').then((res) => {
            this.store = res.school
        }).catch(error => {

            console.error('fetchConfig error:', error)
        })
        
        this.getStage_()
    },

    methods:{
        // 获取进度
        getProgress(total,signs){
            if(total == undefined){
                return 0
            }
            if(signs == undefined){
                return 0
            }
            if(total == 0){
                return 0
            }
            return Math.round(total / signs * 100)
        },
        // 获取顶部阶段进度
        getProgressstag(total,signs,is_complete){
            if(is_complete == undefined){
                return 0
            }
            return Math.round(total / signs * 100)
        },

        getStage_(){
            const loading = this.$loading({
                lock: true,
                text: '疯狂加载中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            var params = {}
            if(this.option_type == 1){
                params.current = this.current
                params.level = this.change_level
            }

            
            Http.getStage(params).then((res) => {
                loading.close()
                
                this.stage = res.data.stage
                this.today_grade = res.data.today_grade
                this.change_level = res.data.level
                this.trem = res.data.trem
                this.level = res.data.level // 学生所在阶段
                this.now_level = res.data.now_level //当前阶段时间周期
                this.current = res.data.current // 当前阶段

                for(let item of this.stage){
                    if(item.name == this.level){
                        this.level_obj = item
                    }
                }
                this.getWorkList();
                this.getStageWork()
            });

        },

        // 获取分层教学题目
        getStageWork(){
            var params = {}
            params.trem = this.trem
            params.level = this.level
            Http.getStageWork(params).then((res) => {
                this.work_data = res.data
            });
        },


        // 获取作业记录
        getWorkList(){
            var params = {}
            params.trem = this.trem
            params.level = this.level
            params.page = this.page
            params.pageSize = this.pageSize
            Http.getStageSubmit(params).then((res) => {
                this.tableData = res.data.list
                this.total_number = res.data.total_number
            });
        },

        // 获取时间线颜色
        getColor(item){

            let now_time = Math.floor(Date.now() / 1000)
            if(now_time > item.starttime && now_time < item.endtime){
                return '#409EFF'
            }else{
                return '#909399'
            }
        },


        goDoWork(level,grade,trem,type){
            var now = new Date().getTime();
            // 将毫秒数转换为秒数并取整
            var timestamp = Math.floor(now / 1000);
  
            if(this.current != level){
                this.$refs.stagework_.getStageWork(level,grade,trem,type);
                return false;
            }
            if(this.now_level.starttime < timestamp && this.now_level.endtime > timestamp){
                this.$refs.stagework_.getStageWork(level,grade,trem,type)
            }else{
                this.$message({
                    message:'学习阶段还未开始',
                    type:'error'
                })
            }
        },

        getLevelValue(levelName){
            const levelMap = {'D':0,'C': 1, 'B': 2, 'A': 3}
            return levelMap[levelName] || 0
        },
        changeLevel(item){

            const studentLevel = this.getLevelValue(this.change_level)
            const currentLevel = this.getLevelValue(this.current)

            if(studentLevel >= currentLevel){
                // 学生已达到或超过当前进度，可以任意切换
                this.option_type = 1
                
                this.level = item.name
                this.getWorkList()
                this.getStageWork()
            }else{
                // 学生层级低于当前进度，只能查看自己的层级
                if(item.name == this.level){
                    // 点击自己的层级，刷新数据
                    this.getWorkList()
                    this.getStageWork()
                }else{
                    this.$message({
                        message:'当前阶段未解锁，只能查看本层内容',
                        type:'error'
                    })
                }
            }
        },
        // 前往详情页
        toDetail(item){
            // 十位时间戳（秒）
            var timestamp = Math.floor(Date.now() / 1000)

            // 条件1：学生所在阶段必须是当前阶段（后台已计算学生可学阶段，未满足上一阶段要求则不能进入下一阶段）
            if(this.level != this.current){
                this.$message({
                    message:'当前阶段未解锁',
                    type:'error'
                })
                return false
            }

            // 条件2：当前阶段必须已经开始（now_level 为该阶段的起止十位时间戳）
            if(!this.now_level || !this.now_level.starttime || timestamp < this.now_level.starttime){
                this.$message({
                    message:'当前阶段未开始，暂未解锁',
                    type:'error'
                })
                return false
            }

            this.$router.push({name:'StageDetail',query:{level:item.level,grade:item.grade,trem:item.trem,type:item.type,title:item.title}});
        },



        // 上一页

        prev(e){

            this.page = e
            this.getWorkList()
        },

        // 下一页
        next(e){

            this.page = e
            this.getWorkList()
        },

        // 点击页码
        changeNumber(e){

            this.page = e
            this.getWorkList()
        },

        // 前往指定页数
        changeSize(e){

            this.page = e
            this.getWorkList()
        },
    }
}
</script>

<style scoped>


.top_label{
    display: flex;
    justify-content: flex-start;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
}

.stag_top_box{
    display: flex;
    justify-content: space-between;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 25px;
    background: #fff;
}

.stag_top_left{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
}
.stag_top_left .icon{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #D9ECFF;
    color: #3197D8;
    border-radius: 5px;
    margin-top: 5px;
}

.stag_top_right{
    display: flex;
    justify-content: flex-start;
    padding: 15px;
    background: #D9ECFF;
    border-radius: 8px;
    box-sizing: border-box;
    gap: 10px;
    font-size: 14px;
    font-weight: 700;
}

.stag_top_right .el-icon-success{
    margin-top: 2px;
    color: #409eff;
}

.stag_top_left_title{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.stag_top_left_title .name{
    font-size: 18px;
    font-weight: 700;
}
.stag_top_left_title .info{
    font-size: 14px;
}

.stag_list_box{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 30px;
}
.stag_list_item{
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
    background: #fff;
    transition: transform 0.3s ease;
    cursor: pointer;
}

.stag_list_item:hover{
    transform: translateY(-5px);
}

.stage_list_active{
    border: 1px solid #409eff;
}


.stag_list_item_top{
    display: flex;
    justify-content: space-between;
}
.stag_list_item_top_left{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}
.stag_list_item_top_left_time{
    display: flex;
    justify-content: flex-start;
    gap: 5px;
    font-size: 12px;
}
.stage_name{
    font-size: 18px;
    font-weight: 700;
}

.stag_list_item_top_left_time .el-icon-date{
    margin-top: 2.5px;
    color: #409eff;
}
.stag_list_item_top_right{
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 5px;
    background: #D9ECFF;
    font-weight: 700;
}

.stag_list_info{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 20px;
    padding: 10px;
    background: #F8FBFE;
    border-radius: 8px;
    box-sizing: border-box;
}

.stag_list_info .el-icon-warning{
    font-size: 24px;
    color: #F56C6C;
}

.stag_list_info_content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    font-size: 14px;
}

.stag_list_info_text{
    display: flex;
    justify-content: flex-start;
    font-size: 12px;
    margin-top: 15px;
}
.stag_work_list{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: 25px;
}
.stag_work_list_item{
    display: flex;
    justify-content: flex-start;
    gap: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.stag_work_list_item_icon{
    display: flex;
    justify-content: center;
    align-items: center;
}
.stag_work_list_item_left{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #D9ECFF;
    border-radius: 50%;
    padding: 10px;
    color: #409EFF;
}

.stag_work_list_item_left .el-icon-trophy{
    font-size: 20px;
}
.stag_work_list_item_right{
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.stag_work_list_item_right_text{
    display: inline-block;
    width: 100%;
    font-size: 12px;
    margin-top: 5px;
    text-align: left;
    opacity: 0.7;
}
.stag_work_list_item_right_name{
    font-size: 14px;
    width: 100%;
    display: inline-block;
    text-align: left;
    font-weight: 700;
}
.stag_work_list_item_right_score{
    font-size: 20px;
    font-weight: 700;
    width: 100%;
    display: flex;
    align-items: flex-end;
    gap: 5px;
}

.stag_info_content{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 25px;
}

.stag_info_content_item{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
}
.stag_info_content_item_right{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    font-size: 14px;
    text-align: left;
}
.stag_info_content_item_right_name{
    font-size: 14px;
    font-weight: 700;
}
.stag_info_content_item_icon{
    color: #409EFF;
}

.stag_task_box{
    display: inline-block;
    width: 100%;
    background: #fff;
    border-radius: 8px;
    margin-top: 25px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}


.stag_task_box_title{
    display: grid;
    grid-template-columns: 80px 370px 1fr 1fr 1fr 1fr 1fr 140px;
    gap: 10px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 700;
    border-bottom: 1px solid #E4E7ED;
}
.stag_task_box_title span{
    padding: 20px;
}

.stag_task_box_item{
    display: grid;
    grid-template-columns: 80px 370px 1fr 1fr 1fr 1fr 1fr 140px;
    gap: 10px;
    box-sizing: border-box;
    font-size: 14px;
    border-bottom: 1px solid #E4E7ED;
}
.stag_task_box_item .item{
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.stag_task_box_item_text{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 20px;
    font-size: 14px;
    gap: 10px;
}
.stag_task_box_item_text i{
    color: red;
    margin-top: 2px;
}

.stag_info_item_text{
    opacity: 0.7;
}
.stage_targetsign{
    font-size: 14px;
}








.stage_body >>> .el-timeline{
    text-align: left;
 
    margin-top: 40px;
}
.stage_body >>> .el-timeline-item{
    padding-bottom: 40px;
}
.timeline >>> .el-card{
    border: none;
}
.top_plan_info_title{
    display: flex;
    justify-content: flex-start;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
}
.top_plan_info_title img{
    width: 23px;
    height: 18px;
    float: left;
}
.top_plan_info_title span{
    float: left;
    margin-left: 10px;
    line-height: 18px;
    font-size: 14px;
    font-weight: 700;
}
.stage_body .greentimelinetitle >>> .el-timeline-item__timestamp{
    color: #1A9D30;
    font-size: 16px;
    margin-bottom: 15px;
    font-weight: 700;
}
.stage_body .greentimelinetitle >>> .el-card__body h4{
    color: #1A9D30;
}
.stage_body .greentimelinetitle >>> .el-card__body p{
    color: #000000;
    font-weight: 600;
}
.stage_body .greentimelinetitle >>> .el-card__body{
    background: #D4EAD8;
}

.stage_body .bluetimelinetitle >>> .el-timeline-item__timestamp{
    color: #3197D8;
    font-size: 16px;
    margin-bottom: 15px;
    font-weight: 700;
}
.stage_body .bluetimelinetitle >>> .el-card__body h4{
    color: #3197D8;
}
.stage_body .bluetimelinetitle >>> .el-card__body p{
    color: #000000;
    font-weight: 600;
}
.stage_body .bluetimelinetitle >>> .el-card__body{
    background: #DCEDF7;
}

.stage_body .yellowtimelinetitle >>> .el-timeline-item__timestamp{
    color: #EC9D5E;
    font-size: 16px;
    margin-bottom: 15px;
    font-weight: 700;
}
.stage_body .yellowtimelinetitle >>> .el-card__body h4{
    color: #EC9D5E;
}
.stage_body .yellowtimelinetitle >>> .el-card__body p{
    color: #000000;
    font-weight: 600;
}
.stage_body .yellowtimelinetitle >>> .el-card__body{
    background: #F8EADF;
}

.stage_body .redtimelinetitle >>> .el-timeline-item__timestamp{
    color: #f56c6c;
    font-size: 16px;
    margin-bottom: 15px;
    font-weight: 700;
}

.stage_body .redtimelinetitle >>> .el-card__body{
    background: #fef0f0;
}

.stage_body .nonebackground >>> .el-card__body{
    background: #E9E9EB;
}


.timeline_info{
    width: 100%;
    display: inline-block;
    text-align: left;
    box-sizing: border-box;
    padding: 10px;
}
.timeline_info span{
    width: 100%;
    display: inline-block;
    line-height: 30px;
    color: #F56C6C;
    font-size: 14px;
    font-weight: 700;
}
.stage_task{
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    padding: 20px;
    
}
.stage_task_left{
    float: left;
    width: 58%;
    background: #F5F7FA;
    padding: 20px;
    border-radius: 6px;
    box-sizing: border-box;
}
.stage_task_left span{
    display: inline-block;

    font-size: 14px;
    margin-left: -120px;
    color: #ADAEB0;
    border-bottom: 1px #ADAEB0 solid;
    padding-top: 8px;
    padding-bottom: 4px;
}
.stage_task_right{
    float: right;
    width: 40%;
    background: #F5F7FA;
    box-sizing: border-box;
    padding: 20px 80px;
    border-radius: 6px;
}
.stage_task_left >>> .el-card__body{
    padding: 7px 10px;
    text-align: left;
    font-size: 14px;
    font-weight: 700;
}
.stage_task_left >>> .el-row{
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-bottom: 10px;
}
.stage_task_left >>> .el-icon-warning{
    margin-top: 10px;
    color: #409EFF;
}
.stage_task_right p{
    margin: 0;
}
.stage_task_right >>> .el-divider{

    margin: 20px 0;
}
.stage_task_right_value{
    float: right;
    color: #409EFF;
    font-size: 18px;
    font-weight: 700;
}
.dowork{
    cursor: pointer;
}
.stag_box{
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: #000000;
}
</style>